// extracted by css-extract-rspack-plugin
export default {"wrapper":"_a1e54857","tilesWrapper":"_83133cf0","tile":"_9e77e890","tileImage":"_110cb817","tileTitle":"_f61ab130"};